import dynamic from 'next/dynamic';

// Defined at module scope, not inside the component: dynamic() returns a new lazy component type on
// every call, so calling it in the render body remounts EmbeddedLogin on each re-render (the Okta
// <Security> provider re-renders the tree as authState settles), flickering the login box on load.
// Must turn off SSR for the embedded okta widget to function.
const ClientSideLogin = dynamic(() => import('../components/Login/EmbeddedLogin'), {
    ssr: false,
});

const Login = () => <ClientSideLogin />;

export default Login;
